<template>
  <MonitorWrapper>
    <el-row class="fcbr-100" :gutter="20">
      <el-col :span="6" style="height: 100%">
        <scrollbar type="none">
          <div slot="scrollbar" class="data-side">
            <WindInfo v-if="showWindInfo" :sn="sn" ref="windInfo" />
            <template v-for="(value, key) in chartData.CHART_LEFT">
              <ChartItem
                v-if="
                  value.deviceTypes.includes(deviceType) && singleDeviceMods.includes(value.type)
                "
                :smoothTimeLineMax="value.smoothTimeLineMax"
                :smoothTimeLine="value.smoothTimeLine"
                :key="key"
                :options="echartObj[key]"
                :title="value.typeName | translateTo"
              />
            </template>
          </div>
        </scrollbar>
      </el-col>
      <el-col :span="12" class="data-center">
        <div class="device-mods">
          <state-mods :curLatestWSData="curLatestWSData" :isHisDetail="isHisDetail"></state-mods>
        </div>
        <div class="device-table">
          <state-table :tableData="tableData" ref="stateTable"></state-table>
        </div>
        <div class="device-bottom">
          <DeviceReportTab :isHisDetail="isHisDetail" />
        </div>
      </el-col>
      <el-col :span="6" style="height: 100%">
        <scrollbar type="none">
          <div slot="scrollbar" class="data-side">
            <template v-for="(value, key) in chartData.CHART_RIGHT">
              <ChartItem
                v-if="
                  value.deviceTypes.includes(deviceType) && singleDeviceMods.includes(value.type)
                "
                :smoothTimeLineMax="value.smoothTimeLineMax"
                :smoothTimeLine="value.smoothTimeLine"
                :key="key"
                :options="echartObj[key]"
                :title="value.typeName | translateTo"
              >
                <template v-if="value.slot === 'gcamera'" #headerButton>
                  <GcameraList :radPicInfo="radPicInfo" />
                </template>
              </ChartItem>
            </template>
          </div>
        </scrollbar>
      </el-col>
    </el-row>
  </MonitorWrapper>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import ChartItem from '@/components/chart-item';

import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import ctt from '@/utils/const';

import echartObj from './options';
import Mixins from './mixins';
import StateTable from './components/state-table';
import StateMods from './components/state-mods';
import DeviceReportTab from '../components/deivce-report-tab';
import { isArray } from '@/utils/is';

export default {
  name: 'RealData',
  components: {
    ChartItem,
    StateTable,
    StateMods,
    DeviceReportTab,
    WindInfo: () => import('./components/wind-info'),
    GcameraList: () => import('./components/gcamera-list')
  },
  mixins: [Mixins, singleDeviceMixin],
  data() {
    return {
      echartObj: echartObj(this.deviceType),
      mods: [
        // 'sysMod',
        'smokeMod',
        'bioMod',
        'tvocMod',
        // 'cwaMod',
        'nuclearMod',
        'gcameraMod',
        'ecMod',
        'imsMod'
      ],
      tableDict: {
        // sysMod: {
        //   sort: 1,
        //   type: 'sysMod',
        //   mod: '温度/气流/自检',
        //   cur: '-',
        //   change: '-',
        //   state: -1,
        //   runstate: -1,
        //   alarmContent: '-'
        // },
        smokeMod: {
          sort: 2,
          type: 'smokeMod',
          mod: '烟雾浓度',
          cur: '-',
          change: '-',
          state: -1,
          runstate: -1,
          alarmContent: '-'
        },
        bioMod: {
          sort: 3,
          type: 'bioMod',
          mod: '生物荧光颗粒',
          cur: '-',
          change: '-',
          state: -1,
          runstate: -1,
          alarmContent: '-'
        },
        tvocMod: {
          sort: 4,
          type: 'tvocMod',
          mod: 'VOCs/CL2/NH3/CO',
          cur: '-',
          change: '-',
          state: -1,
          runstate: -1,
          alarmContent: '-',
          excludes: [ctt.FCBR_100CFR]
        },
        // cwaMod: {
        //   sort: 6,
        //   type: 'cwaMod',
        //   mod: '化学战剂',
        //   cur: '-',
        //   change: '-',
        //   state: -1,
        //   runstate: -1,
        //   alarmContent: '-'
        // },
        imsMod: {
          sort: 6,
          type: 'imsMod',
          mod: 'ims',
          cur: '-',
          change: '-',
          state: -1,
          runstate: -1,
          alarmContent: '-'
        },
        nuclearMod: {
          sort: 7,
          type: 'nuclearMod',
          mod: '核检测(γ/αβ)',
          cur: '-',
          change: '-',
          state: -1,
          runstate: -1,
          alarmContent: '-'
        },
        gcameraMod: {
          sort: 8,
          type: 'gcameraMod',
          mod: '伽马相机(γ)',
          cur: '-',
          change: '-',
          state: -1,
          runstate: -1,
          alarmContent: '-'
        },
        ecMod: [
          // no2 h2s  hcn cocl2  hcl  nh3  so2  co  ch4  ben  cl2          o2  pid
          // origin data
          //   {
          //     sort: 5,
          //     type: 'ecMod',
          //     mod: 'NO2/H2S',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     excludes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 9,
          //     type: 'ecMod',
          //     mod: 'HCN/COCL2',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     excludes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'HCL/NH3/SO2/CO/CH4',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   }
          // new data
          //   {
          //     sort: 5,
          //     type: 'ecMod',
          //     mod: 'NO2',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     excludes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 5,
          //     type: 'ecMod',
          //     mod: 'H2S',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     excludes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 9,
          //     type: 'ecMod',
          //     mod: 'HCN',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     excludes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 9,
          //     type: 'ecMod',
          //     mod: 'COCL2',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     excludes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'HCL',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'NH3',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'SO2',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'CO',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'CH4',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'BEN',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'CL2',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'O2',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   },
          //   {
          //     sort: 4,
          //     type: 'ecMod',
          //     mod: 'PID',
          //     cur: '-',
          //     change: '-',
          //     state: -1,
          //     runstate: -1,
          //     alarmContent: '-',
          //     includes: [ctt.FCBR_100CFR]
          //   }
        ]
      } // 使用数组得更改对应的updateTalbe方式
    };
  },
  computed: {
    ...mapState('socket', ['singleDeviceDetail']),
    ...mapGetters('socket', ['singleDeviceMods']),
    curLatestWSData() {
      // 在实时和详情页中的当前websocket数据
      return this.isHisDetail ? this.historyDetailData : this.singleDeviceDetail;
    },
    showWindInfo() {
      return this.deviceType === ctt.FCBR_100F;
    },
    tableData() {
      let tableData = [];
      this.mods.forEach(m => {
        if (this.singleDeviceMods.indexOf(m) > -1) {
          tableData = tableData.concat(this.tableDict[m]);
        }
      });

      tableData = tableData.filter(e => {
        if (!isArray(e.includes) && !isArray(e.excludes)) return true;

        if (e.includes?.includes(this.deviceType)) return true;

        if (e.excludes?.includes(this.deviceType)) return false;

        return true;
      });

      tableData = tableData.sort((a, b) => a.sort - b.sort);

      return tableData;
    }
  },
  methods: {
    updateData(newVal) {
      try {
        this.setTableDict(newVal);
        this.updateTable(newVal);
        this.updateEchart(newVal);
        this.$refs['stateTable']?.cellStyle();
        this.$refs['windInfo']?.updateWindState(newVal.mods.sysMod.lvState);
      } catch (error) {
        console.log(error);
      }
    },
    setTableDict(newVal) {
      let realMod = [];
      const { ecMod } = newVal.mods;
      Object.keys(ecMod).forEach(item => {
        if (typeof ecMod[item] === 'object') {
          // 代码逻辑
          if (ecMod[item] && ecMod[item].code !== 'UNKNOW') {
            let obj = {
              sort: 5,
              type: 'ecMod',
              mod: ecMod[item].code,
              cur: '-',
              change: '-',
              state: -1,
              runstate: -1,
              alarmContent: '-',
              excludes: [ctt.FCBR_100CFR]
            };
            realMod.push(obj);
          }
        }
      });

      this.tableDict['ecMod'] = realMod;

      //   this.tableDict =
    },
    faultRes(sf, hf) {
      if (sf) {
        return '烟雾故障';
      } else if (hf) {
        return 'ht故障';
      } else {
        return '正常';
      }
    },
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.updateTable(this.historyDetailData);
        this.$refs['stateTable'] && this.$refs['stateTable'].cellStyle();
        this.updateDeviceStateAndSmoke(this.historyDetailData);
        this.historyDetailDatas.forEach(element => {
          this.updateEchart(element);
        });
        this.hideLoading();
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss">
.fcbr-100 {
  height: 100%;
  .data-side,
  .data-center {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .data-side {
    .chart-item {
      min-height: 180px;
      max-height: 300px;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .device-mods {
    height: 20%;
  }
  .device-table {
    height: 48%;
  }
  .device-bottom {
    height: 28%;
  }
  color: #7319e9;
}
</style>
